export default __webpack_public_path__ + "static/media/logo-h.06d26c2a.svg";